import { Table, Form } from "antd";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { Button as BTbutton, Col, Form as BTform, Row } from "react-bootstrap";
import { DoubleLeftOutlined, DoubleRightOutlined } from "@ant-design/icons";

import NewActuacion from "../../pages/Secciones/GestionLegal/Actuaciones/NewActuacion/NewActuacion";

import { useSelector } from "react-redux";
import TooltipText from "../TooltipText";
import Swal from "sweetalert2";
import ModalPDF from "../ModalPDF";
import "./GestionTable.css";
import { actuacionesService } from "../../_services/actuaciones.service";
import Pako from "pako";


const GestionTable = ({ dataList, expandable, selection, filters, RowData, setShowModal, setActuacion, reloadData, handleConvenio, type, grupo, historico, extrajudicial, abogado }) => {
  const { grupoEtapas } = useSelector(e => e.dashboard);

  const [form] = Form.useForm();
  const [data, setData] = useState(dataList);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [rowSelects, setRowSelects] = useState([]);
  const hasSelected = selectedRowKeys.length > 0;

  const [showForm, setShowForm] = useState(false);
  const [newActuacion, setNewActuacion] = useState(false);
  const [tipoActuacion, setTipoActuacion] = useState("");
  const [showPDF, setShowPDF] = useState("");
  const [datosCargados, setDatosCargados] = useState(false);

  useEffect(() => {
    setData(dataList);
  }, [dataList]);

  useEffect(() => {
    const checkDatosCargados = async () => {
      const imponibles = rowSelects.map(({ imponible, recurso }) => {
        return {
          abogado,
          imponible,
          recurso
        };
      });

      const data = Pako.gzip(JSON.stringify(imponibles));
      const res = await actuacionesService.checkRadicacion({ data });

      setDatosCargados(res);
    };

    checkDatosCargados();
  }, [rowSelects]);

  useEffect(() => {
    let find = grupoEtapas.find(e => +e?.id === +grupo);

    setTipoActuacion(find);
  }, [grupoEtapas, grupo]);

  const handleModalOpen = (e, data, show) => {
    setActuacion({
      ...e,
      codexterno: data?.codexterno || "",
      show
    });
    setShowModal(true);
  };

  const handleClose = () => {
    // setShowForm({ show: false, type: "" });
    // setTipoActuacion("");
    // setSelectedRowKeys([]);
    // setRowSelects([]);
    window.location.reload();
  };

  const handleOpen = (type) => {
    setShowForm({
      show: true,
      type
    });
  };

  const handleOpenPDF = (e) => {
    setShowPDF(e);
  };

  const handleClosePDF = () => {
    setShowPDF("");
    return handleClose();
  };


  const handleChange = (id) => {
    let find = grupoEtapas.find(e => +e?.id === +id);

    setTipoActuacion(find);
  };

  const showNewActuacion = () => {
    if (!tipoActuacion) {
      return Swal.fire(
        "Debe seleccionar un tipo de actuación.",
        "",
        "warning"
      );
    }
    if (!datosCargados && tipoActuacion?.nombre === "Judicial") {
      return Swal.fire({
        title: "Debe cargar la radicación para continuar con otras actuaciones.",
        icon: "warning",
        willClose: () => {
          return handleOpen(tipoActuacion?.id);
        }
      });
    } else {
      handleOpen(tipoActuacion?.id);
    }
  };

  //  ---------------- TABLE PROPS ----------------
  const onSelectChange = selectedRowKeys => {
    setSelectedRowKeys(selectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    // type: "radio",
    onChange: onSelectChange,
    onSelect: (record, selected, selectedRows) => {
      setRowSelects(selectedRows);
      if (!selectedRows?.length) {
        handleClose();
      }
    },
    onSelectAll: (selected, selectedRows) => {
      setRowSelects(selectedRows);
      if (!selectedRows) {
        handleClose();
      }
    },
    getCheckboxProps: () => ({
      // disabled: ("A00" !== user?.abogado && e?.codexterno !== user?.abogado),
      disabled: false,
    }),
  };

  const showTotal = (total) => {
    return <span style={{ fontWeight: 600, color: "#17a2b8" }}>TOTAL: {total} resultados</span>;
  };

  const columns = [
    {
      title: "N° DE INMUEBLE",
      dataIndex: "NRO_INMUEBLE",
      key: "NRO_INMUEBLE",
    },
    {
      title: "RECURSO",
      dataIndex: "RECURSO",
      key: "RECURSO",
    },
    {
      title: "DOMICILIO",
      dataIndex: "DOMICILIO",
      key: "DOMICILIO",
    },
    {
      title: "BARRIO",
      dataIndex: "BARRIO",
      key: "BARRIO",
    },
    {
      title: "NOMENCLATURA",
      dataIndex: "NOMENCLATURA",
      key: "NOMENCLATURA",
    },
    {
      title: "PARTIDA",
      dataIndex: "PARTIDA",
      key: "PARTIDA",
    },
    {
      title: "CONTRIBUYENTE",
      dataIndex: "APYNOM",
      key: "APYNOM",
    },
  ];


  const columnsComercio = [
    {
      title: "NRO DE COMERCIO",
      dataIndex: "NRO_COMERCIO",
      key: "NRO_COMERCIO",
    },
    {
      title: "SUCURSAL",
      dataIndex: "SUCURSAL",
      key: "SUCURSAL",
    },
    {
      title: "CONTRIBUYENTE",
      dataIndex: "NOMBRE",
      key: "NOMBRE",
    },
    {
      title: "FANTASIA",
      dataIndex: "NOM_FANTASIA",
      key: "NOM_FANTASIA",
    },
    {
      title: "DOMICILIO",
      dataIndex: "DOMICILIO",
      key: "DOMICILIO",
    },
  ];

  return (
    <div className="gestion-table table-container">
      <Form form={form} component={false}>
        <Table
          bordered
          dataSource={data}
          columns={type === "inmuebles" ? columns : columnsComercio}
          rowClassName="editable-row"
          rowKey={record => record.id}

          rowSelection={(!historico || extrajudicial) && selection && rowSelection}
          expandable={expandable ? {
            expandedRowRender: function A(record, index, indent, expanded) {
              if (expanded) {
                let convenios = [];
                let actuaciones = [];
                let base = [];

                return (
                  <RowData
                    data={record}
                    handleOpen={handleModalOpen}
                    handleConvenio={handleConvenio}
                    reloadData={reloadData}
                    handleOpenPDF={handleOpenPDF}
                    conveniosData={convenios}
                    actuacionesData={actuaciones}
                    baseData={base}
                    type={type}
                    abogado={abogado}
                  />
                );
              }
            },
            expandIcon: function B({ expanded, onExpand, record }) {
              return (
                expanded ? (
                  <TooltipText placement="right" text="Ocultar convenios y actuaciones" >
                    <FontAwesomeIcon icon={faEyeSlash} onClick={e => onExpand(record, e)} size="lg" color="#687073" />
                  </TooltipText>
                ) : (
                  <TooltipText placement="right" text="Mostrar convenios y actuaciones">
                    <FontAwesomeIcon icon={faEye} onClick={e => onExpand(record, e)} size="lg" color="#687073" />
                  </TooltipText>
                )
              );
            },
          } : {}}
          pagination={{
            position: ["none", "bottomRight"],
            showTotal,
            itemRender: (page, type, element) => {
              if (type === "prev") {
                return <DoubleLeftOutlined />;
              }
              else if (type === "next") {
                return <DoubleRightOutlined />;
              }
              return element;
            },
            // showQuickJumper: true,
          }}
        />
      </Form>
      {
        (!historico || extrajudicial) && rowSelects.length ?
          <div className="new-actuacion">
            <div className="d-flex">
              <span style={{ fontSize: 16, fontWeight: 500 }}>
                {hasSelected ? `${selectedRowKeys.length} inmuebles seleccionados` : ""}
              </span>
            </div>
            {!newActuacion ? (
              <div className="d-flex justify-content-center">
                <BTbutton className="custom-button" style={{ maxWidth: 120 }} onClick={() => setNewActuacion(true)} >Actuacion</BTbutton>
              </div>
            ) : null}

            {newActuacion && !showForm.show ? (
              <Row className="justify-content-center align-items-center mt-4 mb-4">
                <Col md={4}>
                  <BTform.Label className="mb-2" style={{ marginTop: 10 }}>
                    <b style={{ color: "red", marginRight: 4 }}>*</b>
                    Tipo de actuación
                  </BTform.Label>
                  <BTform.Control
                    as="select"
                    onChange={(e) => handleChange(e.target.value)}
                    value={tipoActuacion?.id ? tipoActuacion.id : ""}
                  >
                    {grupoEtapas?.length ? grupoEtapas.filter((e) => +grupo === 3 ? (e.id === 2 || e.id === 3) : e.id === +grupo).map(e => {
                      return (
                        <option value={e.id} key={e.id}>{e.nombre}</option>
                      );
                    }) : ""}
                  </BTform.Control>
                </Col>
                <Col md={6}>
                  <div className="d-flex" style={{ marginTop: 35 }}>
                    <BTbutton className="custom-button mr-2" style={{ maxWidth: 220 }} onClick={showNewActuacion} variant="primary">Grabar Nueva Actuación</BTbutton>
                    <BTbutton className="custom-button danger-button" style={{ maxWidth: 220 }} onClick={() => setNewActuacion(false)} variant="danger">Cancelar</BTbutton>
                  </div>
                </Col>
              </Row>
            )
              : null}

            <div>
              {showForm.show ? (
                <NewActuacion type={showForm.type} handleClose={handleClose} reloadData={reloadData} tipoActuacion={tipoActuacion} rowSelects={rowSelects} filters={filters} typeData={type} abogado={abogado} datosCargados={datosCargados} />
              ) : null}
            </div>
          </div>
          : null
      }

      {showPDF ? (
        <ModalPDF show={showPDF} handleClose={handleClosePDF} data={showPDF} />
      ) : ""}
    </div>
  );
};

export default GestionTable;